<!-- /src/compnents/aics/ImageLibrary.vue -->
<template>
  <div class="root-container">
    <div class="image-library">
      <h3 class="tab-title">图片库管理</h3>
      <!-- 操作工具栏 -->
      <div class="toolbar">
        <el-button 
          type="text"
          size="tiny"
          style="font-size: 9pt;margin-right: 20px;"
          @click="HandleCategoryManage">
          <svg t="1763042852245" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5772" width="16" height="16"><path d="M541.2352 468.1216H160.8704A117.3504 117.3504 0 0 1 43.8272 351.0784V117.0432A117.3504 117.3504 0 0 1 160.8704 0h321.8432a117.3504 117.3504 0 0 1 117.0432 117.0432V409.6a58.6752 58.6752 0 0 1-58.5216 58.5216z" fill="#11A1FD" p-id="5773"></path><path d="M863.0784 468.1216h-117.0432A58.6752 58.6752 0 0 1 687.5136 409.6V117.0432A117.3504 117.3504 0 0 1 804.5568 0H863.0784a117.3504 117.3504 0 0 1 117.0432 117.0432v234.0352A117.3504 117.3504 0 0 1 863.0784 468.1216z" fill="#FF9B2C" p-id="5774"></path><path d="M863.0784 1024H541.2352a117.3504 117.3504 0 0 1-116.992-117.0432V614.4a58.6752 58.6752 0 0 1 58.5216-58.5216h380.3648a117.3504 117.3504 0 0 1 117.0432 117.0432v234.0352A117.3504 117.3504 0 0 1 863.0784 1024z" fill="#11A1FD" p-id="5775"></path><path d="M219.648 1024H161.1264a117.3504 117.3504 0 0 1-117.0432-117.0432v-234.0864a117.3504 117.3504 0 0 1 116.8384-116.9408h117.0432a58.6752 58.6752 0 0 1 58.5216 58.5216v292.5568A117.3504 117.3504 0 0 1 219.648 1024z" fill="#5A75F8" p-id="5776"></path><path d="M391.2704 137.5744a25.6 25.6 0 1 0 25.6-25.6 25.6 25.6 0 0 0-25.856 25.6z" fill="#FFFFFF" p-id="5777"></path><path d="M376.6784 214.0672L319.3856 315.1872a17.2544 17.2544 0 0 0 15.0016 25.6h89.0368a34.4576 34.4576 0 0 0 29.2864-52.6336l-46.3872-74.8032a17.2544 17.2544 0 0 0-29.6448 0.5632z" fill="#FFFFFF" opacity=".5" p-id="5778"></path><path d="M264.9088 179.5072L198.912 287.9488a34.4576 34.4576 0 0 0 29.3888 52.3776h161.7408L294.4 179.6608a17.2544 17.2544 0 0 0-29.5424 0z" fill="#FFFFFF" p-id="5779"></path></svg>    
          图片及图文文档分类管理
        </el-button>
        
        <el-button 
          type="text" 
          size="tiny" 
          @click="handleUpload"
          style="font-size: 9pt;margin-right: 20px;">
          <svg t="1764042673859" class="icon" viewBox="0 0 1264 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5576" width="16" height="16"><path d="M992.171444 312.62966C975.189616 137.155482 827.415189 0 647.529412 0 469.849434 0 323.616239 133.860922 303.679205 306.210218 131.598564 333.839271 0 482.688318 0 662.588235c0 199.596576 161.815189 361.411765 361.411765 361.411765h184.014581V692.705882H294.530793l337.939795-361.411764 337.939796 361.411764H726.132229v331.294118H933.647059v-1.555371c185.470975-15.299199 331.294118-170.426291 331.294117-359.856394 0-168.969898-116.101408-310.367302-272.769732-349.958575z" p-id="5577" fill="#1296db"></path></svg>
          上传图片
        </el-button>
        
        <div class="search-box">
          <el-input
            v-model="searchKeyword"
            placeholder="搜索图片名称或描述"
            prefix-icon="el-icon-search"
            size="small"
            style="width: 200px;"
            @keyup.enter.native="handleSearch"
          />
        <el-button 
          type="primary"
          size="tiny"
          style="font-size: 9pt;margin-right: 20px;"
          @click="handleSearch">
         <svg t="1764052713985" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5544" width="16" height="12"><path d="M665.6 607.232c32.768-45.568 53.76-98.816 53.76-156.672 0-148.48-119.296-267.776-267.776-267.776-148.48 0-267.776 119.296-267.776 267.776 0 148.48 119.296 267.776 267.776 267.776 57.856 0 111.104-20.48 156.672-49.664l160.768 160.768c16.384 16.384 41.472 16.384 57.856 0 16.384-16.384 16.384-41.472 0-57.856L665.6 607.232z m-214.528 70.144c-123.904 0-226.816-102.912-226.816-226.816 0-123.904 102.912-226.816 226.816-226.816s226.816 102.912 226.816 226.816c0 123.904-102.912 226.816-226.816 226.816" fill="#ffffff" p-id="5545"></path></svg>    
          搜索
        </el-button>          
        </div>
      </div>

      <!-- 分类筛选 -->
      <div class="category-filter">
        <el-radio-group v-model="selectedCategory" @input="handleCategoryChange">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button 
            v-for="category in categories"
            :key="category.id"
            :label="category.code"
            :value="category.code"
          >        
            {{ category.name }}
            <el-badge v-if="category.imageCount > 0" :value="category.imageCount" class="category-badge" />
          </el-radio-button>
        </el-radio-group>
      </div>

      <!-- 图片网格 -->
      <div class="image-grid-container">
        <div v-if="loading" class="loading-container">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </div>
        
        <div v-else-if="images.length === 0" class="empty-container">
          <el-empty description="暂无图片">
            <el-button type="primary" @click="handleUpload">上传图片</el-button>
          </el-empty>
        </div>
        
        <div v-else class="image-grid">
          <div 
            v-for="image in images" 
            :key="image.id"
            class="image-card"
            @click="handleImagePreview(image)"
          >
            <div class="image-wrapper">
              <img 
                :src="getImageUrl(image)" 
                :alt="image.name"
                :title="image.name"
                @error="handleImageError"
              />
              <div class="image-overlay">
                <div class="image-actions">
                  <el-button 
                    size="mini" 
                    icon="el-icon-view" 
                    @click.stop="handleImagePreview(image)"
                  ></el-button>
                  <el-button 
                    size="mini" 
                    icon="el-icon-edit" 
                    @click.stop="handleEditImage(image)"
                  ></el-button>
                  <el-button 
                    size="mini" 
                    icon="el-icon-delete" 
                    type="danger"
                    @click.stop="handleDeleteImage(image)"
                  ></el-button>
                </div>
              </div>
            </div>
            <div class="image-info">
              <div class="image-name" :title="image.name">{{ image.name }}</div>
              <div class="image-meta">
                <span class="file-size">{{ formatFileSize(image.file_size) }}</span>
                <span class="upload-time">{{ formatTime(image.created_at) }}</span>
              </div>
              <div v-if="image.tags" class="image-tags">
                <el-tag
                  v-for="tag in getTagsArray(image.tags)"
                  :key="tag"
                  size="mini"
                  class="tag"
                >
                  {{ tag }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 分页 -->
        <div v-if="images.length > 0" class="pagination-container">
          <el-pagination
            :current-page="pagination.current"
            :page-size="pagination.size"
            :total="pagination.total"
            layout="total, prev, pager, next, jumper"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </div>

    <!-- 图片预览对话框 -->
    <el-dialog 
      :visible.sync="previewVisible" 
      title="图片预览"
      width="60%"
      top="5vh"
      append-to-body
    >
      <div class="image-preview">
        <img :src="previewImage.url" :alt="previewImage.name" class="preview-img" />
        <div class="preview-info">
          <h3>{{ previewImage.name }}</h3>
          <p><strong>文件大小:</strong> {{ formatFileSize(previewImage.file_size) }}</p>
          <p><strong>上传时间:</strong> {{ formatTime(previewImage.created_at) }}</p>
          <p v-if="previewImage.description"><strong>描述:</strong> {{ previewImage.description }}</p>
          <div v-if="previewImage.tags" class="preview-tags">
            <strong>标签:</strong>
            <el-tag
              v-for="tag in getTagsArray(previewImage.tags)"
              :key="tag"
              size="small"
              class="tag"
            >
              {{ tag }}
            </el-tag>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 图片编辑对话框 -->
    <el-dialog 
      :title="editDialogTitle"
      :visible.sync="editDialogVisible"
      width="500px"
      append-to-body
    >
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="80px">
        <el-form-item label="图片名称" prop="name">
          <el-input v-model="editForm.name" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input 
            type="textarea" 
            v-model="editForm.description" 
            :rows="3"
            placeholder="请输入图片描述"
          />
        </el-form-item>
        <el-form-item label="标签">
          <el-input 
            v-model="editForm.tags" 
            placeholder="多个标签用逗号分隔"
          />
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="editForm.categoryId" placeholder="选择分类" style="width: 100%">
            <el-option label="无分类" :value="null" />
            <el-option 
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveEdit" :loading="saving">保存</el-button>
      </div>
    </el-dialog>


    <!-- 原有的分类管理对话框 -->
<el-dialog title="图片及图文文档分类管理" :visible.sync="open_category" width="1024px" append-to-body>
     <el-button 
     size="tiny"
     style="font-size: 9pt;"
     @click="HandleAddCategory"
     type="text"> <i class="el-icon-plus"></i>添加</el-button>
     <el-button 
     size="tiny"
     style="font-size: 9pt;margin-left: 20px;"
     @click="HandleImportCategory"     
          type="text"> <svg t="1763348307783" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5536" width="10" height="10"><path d="M947.26 577.96a54.296 54.296 0 0 0-54.296 54.288v230.376c0 0.504-0.56 1.208-1.608 1.208H110.5c-1.056 0-1.616-0.704-1.616-1.208V161.376c0-0.512 0.56-1.208 1.616-1.208h191.4a54.288 54.288 0 1 0 0-108.568H110.5C49.74 51.6 0.316 100.84 0.316 161.384v701.248c0 60.528 49.424 109.792 110.184 109.792h780.856c60.752 0 110.184-49.256 110.184-109.792V632.248a54.288 54.288 0 0 0-54.28-54.288z" fill="#1296db" p-id="5537"></path><path d="M1023.356 100.008a54.24 54.24 0 0 0-59.84-48.104c-5.344 0.592-132.504 15.096-267.216 89.432-141.632 78.16-238.824 193.08-286.072 336.552L350.692 305.76a54.28 54.28 0 1 0-102.592 35.496l106.752 308.616a54.312 54.312 0 0 0 69.088 33.552l0.632-0.224 309.424-111.584a54.296 54.296 0 0 0-36.832-102.144l-191.896 69.2c34.664-129.656 115.224-230.552 240.392-300.552 115.944-64.848 228.584-78.16 229.72-78.288a54.272 54.272 0 0 0 47.976-59.824z" fill="#1296db" p-id="5538"></path></svg>
          导入系统默认分类</el-button>
    <el-table v-loading="loading_category" :data="categories">
     <el-table-column label="排序序号" width="70d">   
           <template slot-scope="scope">
               <a style="width: 100%;text-align: center;display:block;" >{{ scope.row.sortOrder }}</a>
           </template>
    </el-table-column>
     <el-table-column label="标题" prop="name" :show-overflow-tooltip="true" width="150" />
        <el-table-column label="编码" prop="code" :show-overflow-tooltip="true" width="150" />
        <el-table-column label="描述" prop="description" :show-overflow-tooltip="true" width="250" />
        
        <el-table-column label="图片数量" prop="imageCount" :show-overflow-tooltip="true" width="80" >
          <template slot-scope="scope">
               <a style="width: 100%;text-align: center;display:block;" >{{ scope.row.imageCount }}</a>
           </template>
    </el-table-column>
        
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"           
            >修改</el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDeleteCategory(scope.row)"          
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  </el-dialog>

    <!-- 分类编辑对话框 -->
    <el-dialog :title="title_categoryedit" :visible.sync="open_categoryedit" width="600px" append-to-body   style="z-index: 13000;" >
             <el-form ref="categoryEditForm" :model="categoryEditForm" :rules="rules_category" label-width="80px">
          <input type="hidden" v-model="categoryEditForm.id">
          <el-row :gutter="10" class="mb8">
            <el-col :span="12">
                <el-form-item label="名称" prop="name">
                  <el-input v-model="categoryEditForm.name" />
                </el-form-item>
              </el-col>         
              <el-col :span="12">
                <el-form-item label="排序序号" prop="sortOrder">
                  <el-input type="number" v-model="categoryEditForm.sortOrder" />
                </el-form-item>
              </el-col>     
              </el-row>
              <el-row :gutter="10" class="mb8">
                  <el-col :span="24">
                      <el-form-item label="编码" prop="odee">
                        <el-input v-model="categoryEditForm.code" v-if="categoryEditForm.id==0"/> <!--添加时可以编辑编码字段 -->
             <el-input v-model="categoryEditForm.code" readonly v-else/> <!--编辑时不可以编辑编码字段 -->                        
                      </el-form-item>
                    </el-col>      
              </el-row>         
              <el-row :gutter="10" class="mb8">
              <el-col :span="24">
                <el-form-item label="描述" prop="description">
                  <el-input type="textarea" rows="3" v-model="categoryEditForm.description" />
                </el-form-item>
              </el-col>                
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm_categoryedit">确 定</el-button>
          <el-button @click="cancel_categoryedit">取 消</el-button>
        </div>
      </el-dialog>
<!-- 图片上传面板 -->
<el-dialog 
  title="上传图片"
  :visible.sync="showUploadPanel"
  width="800px"
  append-to-body
  :close-on-click-modal="false"
>
  <div class="upload-panel">
    <!-- 隐藏的文件输入，用于添加更多文件 -->
    <input
      type="file"
      ref="hiddenFileInput"
      multiple
      accept=".jpg,.jpeg,.png,.gif,.bmp,.webp"
      style="display: none"
      @change="handleHiddenFileSelect"
    />
    <!-- 文件选择区域 - 只在没有选择文件时显示 -->
    <div v-if="selectedFiles.length === 0" class="file-selector">
      <el-upload
        class="upload-area"
        drag
        multiple
        :auto-upload="false"
        :on-change="handleFileSelect"
        :file-list="selectedFiles"
        accept=".jpg,.jpeg,.png,.gif,.bmp,.webp"
        :show-file-list="false"
        action=""
      >
       <svg t="1764054951421" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5584" width="128" height="128"><path d="M791.5 828.5H651.7c-20.7 0-37.3-16.7-37.3-37.3s16.6-37.3 37.3-37.3h139.9c3.9 0 8-0.1 11.7-0.8 47.2-6.7 81.5-46.4 81.5-92.4 0-30.9-15.4-59.8-41.1-77.1-21.6-14.5-34.1-39.2-33.6-65.9 1.7-111.6-65.2-206.5-166.6-237.1-131.5-39.8-278.4 28.7-320.2 149.8-5.1 15-19.3 25.1-35.2 25.1-41.9 0-82.1 17.8-110.4 48.9-28.6 31.5-42.1 72.4-38 115.1 7.2 75.3 76 134.3 156.6 134.3h209.4c20.6 0 37.3 16.7 37.3 37.3s-16.7 37.3-37.3 37.3H296.2c-118.6 0-219.9-88.6-230.9-201.8-6-63 14.8-125.8 57.1-172.4 36.5-40.2 86.4-65.6 139.8-71.8C326.5 239.3 504.9 160.7 665.1 209 798.7 249.4 887 373.4 884.8 517.5c0 0.8-0.1 2.9-0.2 3.8 47.1 31.5 74.8 83.5 74.8 139.2 0 83-61.9 154.3-143.9 166-6.6 1.4-15.3 2-24 2" fill="#C6CCDA" p-id="5585"></path><path d="M513.8 719.2c-20.6 0-37.3-16.7-37.3-37.3V431.7c0-20.6 16.7-37.3 37.3-37.3s37.3 16.7 37.3 37.3v250.2c0 20.6-16.7 37.3-37.3 37.3" fill="#C6CCDA" p-id="5586"></path><path d="M663 580.8c-11 0-21.8-4.8-29.2-14l-120.1-150-120 150c-12.8 16.1-36.3 18.8-52.4 5.8-16.1-12.9-18.7-36.3-5.8-52.4l120.1-150c14.1-17.8 35.4-28 58.2-28 22.8 0 44.1 10.2 58.3 28l120 150c12.9 16.1 10.3 39.6-5.8 52.4-6.9 5.6-15.1 8.2-23.3 8.2" fill="#C6CCDA" p-id="5587"></path></svg>
        <div class="el-upload__text">
          将图片拖到此处，或<em>点击选择</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          支持 jpg、png、gif、bmp、webp 格式，单文件不超过10MB
        </div>
      </el-upload>
    </div>
    <!-- 已选择文件预览 - 只在选择文件后显示 -->
    <div v-else class="selected-files-container">
      <div class="selected-header">
        <h4>已选择图片 ({{ selectedFiles.length }})</h4>
        <el-button 
          type="text" 
          icon="el-icon-refresh"
          @click="clearAllFiles"
        >
          重新选择
        </el-button>
      </div>
      </div>
      <div class="file-previews">
        <div 
          v-for="(file, index) in selectedFiles" 
          :key="index"
          class="file-preview-item"
        >
        <div class="preview-container">
          <img 
            :src="getFilePreview(file)" 
            class="preview-img" 
            @error="handlePreviewError"
            :alt="file.name"
          />
          <div class="preview-overlay">
            <el-button 
              circle 
              size="mini"               
              @click="removeSingleFile(index)"
              class="remove-btn"
              type="danger"
            >
            <svg t="1764060249825" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8520" width="16" height="16"><path d="M718.043429 653.238857a45.787429 45.787429 0 0 1-64.658286 64.731429L512 576.438857 370.614857 717.970286a45.568 45.568 0 0 1-64.658286 0 45.787429 45.787429 0 0 1 0-64.731429l141.385143-141.531428L305.956571 370.102857a45.787429 45.787429 0 0 1 64.658286-64.658286L512 446.902857l141.385143-141.531428a45.714286 45.714286 0 0 1 64.658286 64.658285L576.658286 511.707429 718.043429 653.165714zM512 0C229.668571 0 0 229.668571 0 512s229.668571 512 512 512 512-229.668571 512-512-229.668571-512-512-512z" fill="#d81e06" p-id="8521"></path></svg>
            </el-button>
          </div>
        </div>
          <div class="file-info">
            <div class="file-name" :title="file.name">{{ file.name }}</div>
            <div class="file-size">{{ formatFileSize(file.size) }}</div>
            <div class="file-status" v-if="file.status">
              <el-tag 
                :type="file.status === 'success' ? 'success' : file.status === 'error' ? 'danger' : 'warning'"
                size="mini"
              >
                {{ file.status === 'success' ? '上传成功' : file.status === 'error' ? '上传失败' : '等待上传' }}
              </el-tag>
            </div>
          </div>
        </div>
        
        <!-- 添加更多图片的按钮 -->
        <div  v-if="selectedFiles.length > 0" class="add-more-files" @click="addMoreFiles">      
          <div class="add-icon">
          </div>
<svg t="1764060613392" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9543" width="32" height="32"><path d="M924.9 337.6c-22.6-53.4-54.9-101.3-96-142.4-41.1-41.1-89.1-73.5-142.4-96-55.3-23.5-114-35.3-174.5-35.3S392.8 75.8 337.6 99.1c-53.4 22.6-101.3 54.9-142.4 96-41.1 41.1-73.5 89.1-96 142.4C75.8 392.8 64 451.5 64 512s11.9 119.2 35.2 174.4c22.6 53.4 54.9 101.3 96 142.4 41.1 41.1 89.1 73.5 142.4 96 55.3 23.4 114 35.2 174.5 35.2s119.2-11.9 174.4-35.2c53.4-22.6 101.3-54.9 142.4-96 41.1-41.1 73.5-89.1 96-142.4 23.4-55.3 35.2-114 35.2-174.4 0-60.5-11.8-119.2-35.2-174.4zM512 902.5c-215.3 0-390.5-175.2-390.5-390.5S296.7 121.5 512 121.5 902.5 296.7 902.5 512 727.3 902.5 512 902.5z" p-id="9544" fill="#bfbfbf"></path><path d="M681.7 483.2H540.8v-141c0-15.9-12.9-28.8-28.8-28.8s-28.8 12.9-28.8 28.8v140.9h-141c-15.9 0-28.8 12.9-28.8 28.8s12.9 28.8 28.8 28.8h140.9v140.9c0 15.9 12.9 28.8 28.8 28.8s28.8-12.9 28.8-28.8V540.8h140.9c15.9 0 28.8-12.9 28.8-28.8 0.2-15.9-12.8-28.8-28.7-28.8z" p-id="9545" fill="#bfbfbf"></path></svg>
      </div>
    </div>

    <!-- 图片信息表单 - 只在选择文件后显示 -->
    <div v-if="selectedFiles.length > 0" class="image-info-form">
      <el-divider content-position="left">图片信息</el-divider>
      <el-form :model="uploadForm" label-width="80px">
        <el-form-item label="图片名称">
          <el-input 
            v-model="uploadForm.name" 
            placeholder="请输入图片名称（留空使用文件名）"
          />
          <div class="form-tip">多文件上传时，此名称将作为前缀</div>
        </el-form-item>
        <el-form-item label="描述">
          <el-input 
            type="textarea" 
            v-model="uploadForm.description" 
            :rows="3"
            placeholder="请输入图片描述"
          />
        </el-form-item>
        <el-form-item label="标签">
          <el-input 
            v-model="uploadForm.tags" 
            placeholder="多个标签用逗号分隔"
          />
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="uploadForm.categoryCode" placeholder="选择分类" style="width: 100%">
            <el-option label="无分类" :value="null" />
            <el-option 
              v-for="category in categories"
              :key="category.code"
              :label="category.name"
              :value="category.code"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <!-- 上传进度 -->
    <div v-if="isUploading" class="upload-progress">
      <el-divider content-position="left">上传进度</el-divider>
      <el-progress
        :percentage="uploadProgress"
        :status="uploadError ? 'exception' : (uploadProgress === 100 ? 'success' : undefined)"
        :stroke-width="8"
        :show-text="true"
      />
      <div class="upload-status">
        <div v-if="isUploading && uploadProgress < 100" class="uploading-text">
          <i class="el-icon-loading"></i>
          图片上传中，请稍候...
        </div>
        <div v-else-if="uploadProgress === 100" class="success-text">
          <i class="el-icon-success"></i>
          上传完成！
        </div>
        <div v-else-if="uploadError" class="error-text">
          <i class="el-icon-error"></i>
          {{ uploadError }}
        </div>
      </div>
    </div>
  </div>
  
  <div slot="footer">
    <el-button @click="cancelUpload" :disabled="isUploading">取消</el-button>
    <el-button 
      type="primary" 
      @click="handleSubmitUpload" 
      :disabled="selectedFiles.length === 0 || isUploading"
      :loading="isUploading"
    >
      {{ isUploading ? `上传中 (${uploadProgress}%)` : '提交上传' }}
    </el-button>
  </div>
</el-dialog>    

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { SYSTEM_CATEGORIES } from '@/api/aics/ImageCategoryConstants'
import {
  getCategories, addCategory, updateCategory, getCategoryDetail, deleteCategory, importDefaultCategory,
   updateImage, deleteImage, getImages,uploadImageToOSS, saveImageInfo 
} from '@/api/aics/image'
import { MessageBox } from 'element-ui'

export default {
  name: 'ImageLibrary',
  data() {
    return {
      // 图片相关数据
      images: [],
      loading: false,
      searchKeyword: '',
      selectedCategory: '',
      
      // 分页
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },
      
      // 预览相关
      previewVisible: false,
      previewImage: {},
      
      // 编辑相关
      editDialogVisible: false,
      editDialogTitle: '编辑图片信息',
      editForm: {
        id: null,
        name: '',
        description: '',
        tags: '',
        categoryId: 0
      },
      // 上传相关数据
      uploadForm: {
        name: '',
        description: '',
        tags: '',
        categoryCode: null
      },
      isUploading: false,
      uploadProgress: 0,
      uploadError: '',
      showUploadPanel: false, // 控制上传面板显示
      selectedFiles: [], // 预览选中的文件      
      editRules: {
        name: [
          { required: true, message: '请输入图片名称', trigger: 'blur' }
        ]
      },
      saving: false,
      
      // 上传相关
      uploadDialogVisible: false,
      uploadUrl: process.env.VUE_APP_BASE_API + '/api/images/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + this.$store.getters.token
      },
      uploadData: {
        tenantId: 0
      },
      
      // 原有的分类管理数据
      systemCategories: Object.values(SYSTEM_CATEGORIES),
      open_category: false,
      open_categoryedit: false,
      title_categoryedit: '',
      categories: [],
      loading_category: false,
      categoryEditForm: {
        id: 0,
        name: '',
        description: '',
        sortOrder: 1,
        tenantId: 0,
      },
      rules_category: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入目录编码", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        sortOrder: { required: true, message: "请输入排序序号", trigger: "blur" },
      }
    }
  },
  
  created() {
    if(this.tenantInfo && this.tenantInfo.status && this.tenantInfo.status.trim()!=='APPROVED'){
    this.$message.error('租户状态未激活');  
    this.logout();
}  
    this.loadCategories()

  },
// 在 beforeDestroy 或 destroyed 生命周期中
beforeDestroy() {
  this.cleanupPreviewURLs()
},  
  computed: {    
    ...mapState('auth', ['tenantInfo', 'userInfo','loginType']),    

    tenantId() {
      return this.tenantInfo?.tenantId || null;
    }
  },  
  methods: {
    // 加载分类
    loadCategories() {
      getCategories(this.tenantId).then(res => {
        console.log("getCategories",res)
        if (res.data.code === 200) {
          this.loadImageList()
          this.categories = res.data.data
        }
        console.log(this.categories)
      })
    },
    
    // 加载图片列表
    loadImageList() {
      this.loading = true
      const params = {
        tenantId: this.tenantId,
        categoryCode: this.selectedCategory,
        keyword: this.searchKeyword,
        page: this.pagination.current - 1,
        size: this.pagination.size
      }
      console.log("loadImageList", params);
      getImages(params).then(res => {
        console.log(res);
        this.loading = false
        if (res.data.code === 200) {
          this.images = res.data.data.content
          this.pagination.total = res.data.data.totalElements || this.images.length
          console.log(this.images, this.pagination.total);
        } else {
          this.$message.error('加载图片失败')
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('加载图片失败')
      })
    },
    
    // 分类切换
    handleCategoryChange(val) {      
      console.log("handleCategoryChange", val)
      this.selectedCategory = val
      this.pagination.current = 1
      this.loadImageList()
    },
    
    // 搜索
    handleSearch() {
      this.pagination.current = 1
      this.loadImageList()
    },
    
    // 分页变化
    handlePageChange(page) {
      this.pagination.current = page
      this.loadImageList()
    },
    
    // 获取图片URL
    getImageUrl(image) {
      //console.log("getImageUrl", image);
      return image.temp_url
    },
    
    // 图片加载失败处理
    handleImageError(event) {
      event.target.src = '/static/images/image-error.png'
    },
    
    // 图片预览
    handleImagePreview(image) {
      console.log("handleImagePreview",image)
      this.previewImage = {
        ...image,
        url: this.getImageUrl(image)
      }
      this.previewVisible = true
    },
    
    // 编辑图片
    handleEditImage(image) {
      console.log(image);
 /*     let categoryCode = "";
      for(var i=0;i<this.categories.length;i++){
        if(this.categories[i].id==image.category_id){
          categoryCode = this.categories[i].code;
          break;
        }
      }
*/

      this.editForm = {
        id: image.id,
        name: image.name,
        description: image.description || '',
        tags: image.tags || '',
        categoryId: image.category_id,
      }
      console.log(this.editForm);
      this.editDialogVisible = true
    },
    
    // 保存编辑
    handleSaveEdit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.saving = true
          updateImage(this.editForm).then(res => {
            this.saving = false
            console.log(res);
            if (res.data.code === 200) {
              this.$message.success('保存成功')
              this.editDialogVisible = false
              this.loadImageList()
            } else {
              this.$message.error(res.data.message)
            }
          }).catch(() => {
            this.saving = false
            this.$message.error('保存失败')
          })
        }
      })
    },
    
    // 删除图片
    handleDeleteImage(image) {
      console.log("handleDeleteImage", image)
        MessageBox.confirm(`确定删除图片 "${image.name}" 吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        deleteImage(image.id).then(res => {
          console.log(res);
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadImageList()
          } else {
            this.$message.error(res.data.message)
          }
        }).catch(() => {
          this.$message.error('删除失败')
        })
      })
    },
    
    // 打开上传对话框
    handleUpload() {
      this.showUploadPanel = true
    },
    
    // 上传前校验
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB!')
      }
      
      return isImage && isLt10M
    },
    
    // 上传成功
    handleUploadSuccess(response) {
      if (response.code === 200) {
        this.$message.success('上传成功')
        this.uploadDialogVisible = false
        this.loadImageList()
      } else {
        this.$message.error(response.message || '上传失败')
      }
    },
    
    // 上传失败
    handleUploadError(error) {
      this.$message.error('上传失败')
      console.error('Upload error:', error)
    },
    
    // 工具方法
    formatFileSize(bytes) {
      if (!bytes) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },    
    formatTime(timeArray) {
      if (!timeArray || !Array.isArray(timeArray) || timeArray.length < 3) {
        return ''
      }
      
      try {
        // 数组格式: [年, 月, 日, 时, 分, 秒, 纳秒]
        let year = timeArray[0]
        let month = timeArray[1]
        let day = timeArray[2]
        let hour = timeArray[3] || 0
        let minute = timeArray[4] || 0
        
        // 转换为北京时间 (UTC+8)
        hour = hour + 8
        if (hour >= 24) {
          hour = hour - 24
          day = day + 1
          // 处理月份和年份的进位（简化版，实际项目建议使用更完整的日期计算）
          if (day > new Date(year, month, 0).getDate()) {
            day = 1
            month = month + 1
            if (month > 12) {
              month = 1
              year = year + 1
            }
          }
        }
        
        const monthStr = String(month).padStart(2, '0')
        const dayStr = String(day).padStart(2, '0')
        const hourStr = String(hour).padStart(2, '0')
        const minuteStr = String(minute).padStart(2, '0')
        
        return `${year}-${monthStr}-${dayStr} ${hourStr}:${minuteStr}`
      } catch (e) {
        console.error('时间格式化错误:', e)
        return ''
      }
    },
    
    getTagsArray(tags) {
      if (!tags) return []
      return tags.split(',').map(tag => tag.trim()).filter(tag => tag)
    },
    
    // 原有的分类管理方法保持不变
    HandleCategoryManage() {
          this.open_category = true
      this.loading_category = true
      this.refreshTable()
    },
    
    refreshTable() {
      getCategories(this.tenantId).then(res => {
        console.log(res)
        if (res.data.code === 200) {
          this.categories = res.data.data
        }
        this.loading_category = false        
      })
    },
    
    HandleAddCategory() {
      this.reset_categoryEditForm()
      this.title_categoryedit = "添加图片分类"
      this.open_categoryedit = true
    },
    
    HandleImportCategory() {
      let that = this
      this.$confirm('系统将导入默认分类，已存在的分类不会被删除。是否继续？').then(function() {
        importDefaultCategory(that.tenantId).then(res => {
          if (res.data.code === 200) {
            that.$message.success('导入成功。如果默认分类与您的业务和不匹配，您可以自行管理分类。')
            that.refreshTable()
          }
        })
      })
    },
    
    handleUpdate(row) {
      getCategoryDetail(row.id).then(response => {
        if (response.data.code === 200) {
          this.categoryEditForm = response.data.data
          this.open_categoryedit = true
        }
      })
    },
    
    handleDeleteCategory(row) {
      let that = this
      this.$confirm('是否确认删除"' + row.name + '"？').then(function() {
        deleteCategory(row.id).then(res => {
          console.log(res.data)
          if (res.data.code === 200) {
            that.$message.success('删除成功')
            that.refreshTable()
          }
        })
      })
    },
    
    submitForm_categoryedit() {
      this.$refs["categoryEditForm"].validate(valid => {
        if (valid) {
          if (this.categoryEditForm.id) {
            updateCategory(this.categoryEditForm).then(response => {
              console.log(response)
              if(response.data.code == 200){
                this.$message.success("修改成功")
                this.open_categoryedit = false
                this.refreshTable()
              }else{
                this.$message.error( response.data.message)
              }            
            });
          } else {
            this.$set(this.categoryEditForm, 'id', 0)
            this.$set(this.categoryEditForm, 'code',     this.generateUUID())
                        this.$set(this.categoryEditForm, 'tenantId', this.tenantId)
            addCategory(this.categoryEditForm).then(response => {
            console.log(response.data)
            if(response.data.code == 200){
              this.$message.success("新增成功")
              this.open_categoryedit = true
              this.refreshTable()
            }
            else{
                this.$message.error(response.data.message)
            }
            })
          }
        }
      })
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },    
    reset_categoryEditForm() {
      this.categoryEditForm = {
        id: 0,
        name: '',
        code: '',
        description: '',
        sortOrder: 1,
        tenantId: this.tenantId,
      }
    },
    
    cancel_categoryedit() {
      this.open_categoryedit = false
    },

    // 以下是图片上传相关代码
    // 文件选择处理
     handleFileSelect(file) {
    if (!this.validateFile(file)) {
      return false
    }
    
    // 为文件添加状态
    const fileWithStatus = {
      ...file,
      status: 'pending' // pending, uploading, success, error
    }
    
    this.selectedFiles = [...this.selectedFiles, fileWithStatus]
    return true
  },
  
  // 统一的文件验证
  validateFile(file) {
    const actualFile = file.raw || file
    
    // 验证是否是有效的文件对象
    if (!(actualFile instanceof File)) {
      this.$message.error('无效的文件对象')
      return false
    }
    
    // 验证文件类型
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/webp']
    if (!allowedTypes.includes(actualFile.type)) {
      this.$message.error(`文件 "${actualFile.name}" 不支持，请选择图片文件`)
      return false
    }
    
    // 验证文件大小 (10MB)
    const maxSize = 10 * 1024 * 1024
    if (actualFile.size > maxSize) {
      this.$message.error(`文件 "${actualFile.name}" 大小超过10MB限制`)
      return false
    }
    
    return true
  },



// 隐藏文件输入的选择处理
handleHiddenFileSelect(event) {
  const files = Array.from(event.target.files)
  files.forEach(file => {
    if (this.validateFile(file)) {
      const fileWithStatus = {
        name: file.name,
        size: file.size,
        type: file.type,
        raw: file, // 直接使用 file 对象
        status: 'pending'
      }
      this.selectedFiles.push(fileWithStatus)
    }
  })
  
  // 重置文件输入
  event.target.value = ''
},
    // 添加上传前的整体验证
    validateUpload() {
      if (this.selectedFiles.length === 0) {
        this.$message.warning('请选择要上传的图片')
        return false
      }
      
      // 检查是否有重复文件名
      const fileNames = this.selectedFiles.map(f => f.name)
      const uniqueNames = new Set(fileNames)
      if (uniqueNames.size !== fileNames.length) {
        this.$message.warning('存在重复文件名，请修改后重新上传')
        return false
      }
      
      return true
    },
      
    handleFileRemove(file) {
      const index = this.selectedFiles.indexOf(file)
      if (index > -1) {
        this.selectedFiles.splice(index, 1)
      }
    },    
    // 获取文件预览URL
    getFilePreview(file) {
      try {
        // 如果已经有缓存的 URL，直接返回
        if (file.previewURL) {
          return file.previewURL
        }
        
        const actualFile = file.raw || file
        
        if (actualFile instanceof File || actualFile instanceof Blob) {
          const previewURL = URL.createObjectURL(actualFile)
          // 缓存 URL 以便后续清理
          file.previewURL = previewURL
          return previewURL
        } else {
          console.warn('无效的文件对象:', actualFile)
          return ''
        }
      } catch (error) {
        console.error('生成预览URL失败:', error)
        return ''
      }
    }, 
    
    // 提交上传
     async handleSubmitUpload() {      
        if (this.selectedFiles.length === 0) {
          this.$message.warning('请选择要上传的图片')
          return
        }
        if (!this.validateUpload()) {
          return
        }
        this.isUploading = true
        this.uploadProgress = 0
        this.uploadError = ''
        
        try {
          let successCount = 0
          const totalFiles = this.selectedFiles.length
          
          for (let i = 0; i < this.selectedFiles.length; i++) {
            const file = this.selectedFiles[i]
            
            try {
              // 1. 前端直传OSS
              this.uploadProgress = Math.round((i / totalFiles) * 70)
              this.$message.info(`正在上传: ${file.name}`)
              
              const uploadResult = await this.uploadFileToOSS(file)
              
              if (uploadResult.code === 200 && uploadResult.data.success) {
                // 2. 保存图片信息到应用端
                this.uploadProgress = Math.round((i / totalFiles) * 70 + 30)
                await this.saveImageInfo(file, uploadResult.data)
                successCount++
                
                this.$message.success(`图片 ${file.name} 上传成功`)
              } else {
                throw new Error(uploadResult.message || 'OSS上传失败')
              }
            } catch (error) {
              console.error(`文件 ${file.name} 上传失败:`, error)
              this.uploadError = `文件 ${file.name} 上传失败: ${error.message}`
              this.$message.error(`图片 ${file.name} 上传失败`)
            }
          }
          
          this.uploadProgress = 100
          
          if (successCount > 0) {
            this.$message.success(`成功上传 ${successCount}/${totalFiles} 张图片`)
            this.showUploadPanel = false
            this.resetUploadForm()
            this.loadImageList() // 刷新图片列表
          } else {
            this.$message.error('所有图片上传失败，请检查网络或文件格式')
          }
          
        } catch (error) {
          console.error('上传过程出错:', error)
          this.uploadError = error.message
          this.$message.error('上传过程发生错误')
        } finally {
          this.isUploading = false
        }
      },
    
      // 上传文件到OSS
      async uploadFileToOSS(file) {
        const actualFile = file.raw || file
        return await uploadImageToOSS(actualFile, this.tenantId)
      },
    
    // 保存图片信息到应用端
    async saveImageInfo(file, ossData) {
      console.log(ossData);
      const imageData = {
        name: this.uploadForm.name || file.name.replace(/\.[^/.]+$/, ""), // 去掉扩展名
        originalFilename: file.name,
        ossObjectKey: ossData.objectKey,
        filePath: ossData.fileKey, // 使用OSS key作为文件路径
        fileSize: file.size,
        mimeType: file.type,
        description: this.uploadForm.description,
        tags: this.uploadForm.tags,
        categoryCode: this.uploadForm.categoryCode,
        tenantId: this.tenantId,
        createdBy: this.userInfo?.username // 根据实际用户信息调整
      }
      
      try {
        const response = await saveImageInfo(imageData)
        return response
      } catch (error) {
        throw new Error('保存图片信息失败: ' + (error.message || '未知错误'))
      }
    },    
  // 删除单个文件
  removeSingleFile(index) {
    this.selectedFiles.splice(index, 1)
  },
  
  // 清空所有文件
  clearAllFiles() {
    this.selectedFiles = []
  },
  
  // 添加更多文件
  addMoreFiles() {
    // 使用隐藏的文件输入元素
    this.$refs.hiddenFileInput.click()
  },
    // 取消上传
    cancelUpload() {
      if (this.isUploading) {
        this.$confirm('上传正在进行中，确定要取消吗？', '提示', {
          type: 'warning'
        }).then(() => {
          this.showUploadPanel = false
          this.resetUploadForm()
        })
      } else {
        this.showUploadPanel = false
        this.resetUploadForm()
      }
    },
    
    // 重置上传表单
    resetUploadForm() {
      // 清理预览URL
      this.cleanupPreviewURLs()
      
      this.selectedFiles = []
      this.uploadForm = {
        files: [],
        name: '',
        description: '',
        tags: '',
        categoryCode: null
      }
      this.isUploading = false
      this.uploadProgress = 0
      this.uploadError = ''
      },
      // 清理预览URL，避免内存泄漏
      cleanupPreviewURLs() {
        this.selectedFiles.forEach(file => {
          if (file.previewURL) {
            URL.revokeObjectURL(file.previewURL)
          }
        })
      },

    // 图片预览加载错误处理
    handlePreviewError(event) {
      console.error('图片预览加载失败:', event)
      // 可以设置一个默认的占位图片
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik0zNSA0MEw1MCA1NUw2NSA0MCIgc3Ryb2tlPSIjQ0NDQ0NDIiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3QgeD0iMzUiIHk9IjI1IiB3aWR0aD0iMzAiIGhlaWdodD0iMjAiIHJ4PSIyIiBzdHJva2U9IiNDQ0NDQ0MiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K'
    },

        async logout() {
      try {
        // 调用 Vuex 中的 logout action
        await this.$store.dispatch('auth/logout')
        // 退出成功后跳转到登录页
        this.$router.push('/login')
      } catch (error) {
        console.error('退出登录失败:', error)
        // 即使退出API调用失败，也强制清除本地状态并跳转
        this.$store.commit('auth/CLEAR_AUTH')
        this.$router.push('/login')
      }
    },
  }
}
</script>

<style scoped>
.root-container {
  padding: 20px;
  background: #fff;
  min-height: calc(100vh - 84px);
}

.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 4px;
}

.search-box {
  display: flex;
  align-items: center;
}

.category-filter {
  margin-bottom: 20px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 4px;
}

.category-badge {
  margin-left: 4px;
}

.image-grid-container {
  min-height: 400px;
}

.loading-container, .empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #909399;
}

.loading-container i {
  font-size: 32px;
  margin-bottom: 16px;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.image-card {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s;
  background: #fff;
  cursor: pointer;
}

.image-card:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.image-wrapper {
  position: relative;
  width: 100%;
  height: 150px;
  overflow: hidden;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.image-card:hover .image-wrapper img {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.image-card:hover .image-overlay {
  opacity: 1;
}

.image-actions {
  display: flex;
  gap: 8px;
}

.image-info {
  padding: 12px;
}

.image-name {
  font-weight: 500;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
}

.image-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.tag {
  margin: 2px;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.image-preview {
  display: flex;
  gap: 20px;
}

.preview-img {
  max-width: 60%;
  max-height: 60vh;
  object-fit: contain;
}

.preview-info {
  flex: 1;
}

.preview-info h3 {
  margin-top: 0;
  margin-bottom: 16px;
}

.preview-info p {
  margin-bottom: 12px;
}

.preview-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

/* 上传面板样式 */
.upload-panel {
  max-height: 70vh;
  overflow-y: auto;
}

.upload-area {
  width: 100%;
  min-height: 200px;
  text-align: center;
}

/* 已选择文件容器 */
.selected-files-container {
  margin-top: 0;
}

.selected-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e4e7ed;
}

.selected-header h4 {
  margin: 0;
  color: #303133;
}

/* 文件预览网格 */
.file-previews {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.file-preview-item {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
  transition: all 0.3s;
  position: relative;
}

.file-preview-item:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.preview-container {
  position: relative;
  width: 100%;
  height: 100px;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f7fa;
  margin-bottom: 8px;
}

.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.preview-container:hover .preview-overlay {
  opacity: 1;
}

.remove-btn {
  background: rgba(255, 255, 255, 0.9);
}

.file-info {
  text-align: center;
}

.file-name {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}

.file-size {
  font-size: 11px;
  color: #909399;
  margin-bottom: 4px;
}

.file-status {
  margin-top: 4px;
}

/* 添加更多文件按钮 */
.add-more-files {
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 140px;
  cursor: pointer;
  transition: all 0.3s;
  color: #909399;
}

.add-more-files:hover {
  border-color: #409eff;
  color: #409eff;
  background: #f0f7ff;
}

.add-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.add-text {
  font-size: 12px;
}

/* 图片信息表单 */
.image-info-form {
  margin-top: 20px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

/* 上传进度 */
.upload-progress {
  margin-top: 20px;
}

.upload-status {
  margin-top: 8px;
  text-align: center;
}

.uploading-text, .success-text, .error-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .file-previews {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 12px;
  }
  
  .preview-container {
    height: 80px;
  }
}

/* 修复下拉箭头显示问题 */
:deep(.el-select .el-input .el-select__caret) {
  font-family: element-icons !important;
}

/* 默认状态 - 下箭头 */
:deep(.el-select .el-input .el-select__caret:before) {
  content: "\e790";
}

/* 展开状态 - 上箭头 */
:deep(.el-select .el-input.is-focus .el-select__caret:before),
:deep(.el-select .el-input .el-select__caret.el-icon-arrow-up:before) {
  content: "\e78f";
}
.tab-title {
  color: #333;
  margin-bottom: 25px;
  font-size: 1.5rem;
  font-weight: 500;
}
</style>